import ChangeUserPasswordModal from './ChangeUserPasswordModal';

export default ChangeUserPasswordModal;
